import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "OrderDetails",
    component: () => (__SERVER__ ? require("./order-details-view") : import("./order-details-view"))
});

export default definition;
